<div class="modal-header">
	<div>
		<h4 class="modal-title">Sucursal: <strong>{{sucursal}}</strong></h4>
		<small class="subtitle">Zona: {{zona}} - Consecutivo: {{consecutivo}} - {{alias_id_ext}}: {{id_ext}}</small>
	</div>
</div>

<mat-divider class="mt-2"></mat-divider>

<mat-dialog-content class="mt-2">
	<div class="modal-body">
		<div class="row g-3 card-first">
			<div class="col-md-6 ">
				<mat-card class="info-card2">
					<mat-card-content>
						<div class="d-flex justify-content-between align-items-center">
							<h6 class="mt-1"><b>Encuesta</b></h6>
						</div>
						<mat-divider></mat-divider>
						<div class="mt-3 d-flex justify-content-between">
							<span>Responsable</span><span><b>{{responsable}}</b></span>
						</div>
						<div class="d-flex justify-content-between">
							<span>Puesto</span><span><b>{{puesto}}</b></span>
						</div>
						<div class="d-flex justify-content-between">
							<span class="me-4">Comentarios</span><span class="text-end"><b>{{comentarios}}</b></span>
						</div>
						<div class="d-flex justify-content-between">
							<span>Fecha de respuesta</span><span><b> {{ fecha_respuesta | date:'d/M/yyyy' }}</b></span>
						</div>
					</mat-card-content>
				</mat-card>
			</div>

			<div class="col-md-6">
				<mat-card class="info-card">
					<mat-card-content>
						<div class="d-flex justify-content-between align-items-center">
							<h6 class="mt-1"><b>Alertas</b></h6>
						</div>
						<mat-divider></mat-divider>
						
							<!--Barra horizontal-->
							<div class="progress mt-3" style="height: 15px;">
								<ng-container *ngFor="let tipo of ['Material dañado','Kit incompleto','Faltante','Otro']">
									<div
										*ngIf="conteoTipos[tipo] > 0"
										class="progress-bar"
										[ngClass]="{
											'bg-danger': tipo === 'Material dañado',
											'bg-warning': tipo === 'Kit incompleto',
											'bg-info': tipo === 'Faltante',
											'bg-primary': tipo === 'Otro',
											'rounded-start': esPrimero(tipo),
											'rounded-end': esUltimo(tipo)
										}"
										role="progressbar"
										[style.width.%]="(conteoTipos[tipo] / totalAlertas) * 100"
									>
										{{ conteoTipos[tipo] }}
									</div>
								</ng-container>
							</div>

							<!--Leyendas alertas-->
							<ul class="list-unstyled mt-3 mb-0">
								<li class="d-flex align-items-center mb-1" *ngIf="conteoTipos['Material dañado'] > 0">
									<span class="dot bg-danger me-2"></span> Material dañado: {{ conteoTipos['Material dañado'] }}
								</li>
								<li class="d-flex align-items-center mb-1" *ngIf="conteoTipos['Kit incompleto'] > 0">
									<span class="dot bg-warning me-2"></span> Kit incompleto: {{ conteoTipos['Kit incompleto'] }}
								</li>
								<li class="d-flex align-items-center mb-1" *ngIf="conteoTipos['Faltante'] > 0">
									<span class="dot bg-info me-2"></span> Faltante: {{ conteoTipos['Faltante'] }}
								</li>
								<li class="d-flex align-items-center" *ngIf="conteoTipos['Otro'] > 0">
									<span class="dot bg-primary me-2"></span> Otro: {{ conteoTipos['Otro'] }}
								</li>
							</ul>

					</mat-card-content>
				</mat-card>
			</div>
		</div>

		<div class="mt-3">

			<div class="row align-items-center">
				<div class="col-md-6">
					<h5 class="align-items-center mb-0 fw-bold">Materiales totales: {{totalMateriales}}</h5>
				</div>
				<div class="col-md-6 align-items-center">
					<div class="d-flex justify-content-end">
						<button *ngIf="dataImages.length > 0" mat-raised-button (click)="descargarZIP()" style="background-color: #E0EEFF;">
							<mat-icon class="me-2">download</mat-icon>Descargar evidencias
						</button>
					</div>
				</div>
			</div>
			
			<mat-divider class="mt-2"></mat-divider>

			<div class="row g-3 mt-1">

				<div class="col-md-7 card-materials">
					<div class="table-responsive text-nowrap">
						<table mat-table [dataSource]="dataSource" class="w-100">
							<ng-container matColumnDef="id">
								<th mat-header-cell *matHeaderCellDef> ID </th>
								<td mat-cell *matCellDef="let row"> {{row.id}} </td>
							</ng-container>
							<ng-container matColumnDef="nombre">
								<th mat-header-cell *matHeaderCellDef> Nombre </th>
								<td mat-cell *matCellDef="let row"> {{row.nombre}} </td>
							</ng-container>

							<ng-container matColumnDef="cantidad">
								<th mat-header-cell *matHeaderCellDef> Cantidad </th>
								<td mat-cell *matCellDef="let row"> {{row.cantidad}} </td>
							</ng-container>

							<ng-container matColumnDef="status">
								<th mat-header-cell *matHeaderCellDef> Estatus </th>
								<td mat-cell *matCellDef="let row"> 
									<span *ngIf="row.status != 1"
										class="badge rounded-pill text-dark fw-bold"
										[ngClass]="{
											'bg-success': row.status === 2,
											'bg-warning': row.status === 3
										}"
										>
										{{row.status == 3 ? 'Alerta' : 'Perfecto'}}
									</span>	
							</ng-container>

							<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
							<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

						</table>
					</div>
				</div>

				<div class="col-md-5">

					<div class="text-center p-3">
					<h5 class="fw-bold mb-3">Evidencias</h5>

					<div *ngIf="dataImages.length == 0">No hay evidencias disponibles</div>

					<div class="position-relative" *ngIf="dataImages.length > 0">
						<!--Imagen actual-->
						<img
							[src]="dataImages[currentIndex]?.file"
							class="img-fluid rounded shadow-sm"
							style="max-height: 250px; object-fit: contain;"
							alt="Evidencia"
						/>

						<!--Botones de navegación-->
						<button
							mat-icon-button
							class="nav-btn start-0"
							(click)="anterior()"
							[disabled]="dataImages.length <= 1"
						>
							<mat-icon>chevron_left</mat-icon>
						</button>
						<button
							mat-icon-button
							class="nav-btn end-0"
							(click)="siguiente()"
							[disabled]="dataImages.length <= 1"
						>
							<mat-icon>chevron_right</mat-icon>
						</button>
					</div>

					<!--Indicadores-->
					<div class="d-flex justify-content-center mt-3" *ngIf="dataImages.length > 0">
						<span
							*ngFor="let img of dataImages; let i = index"
							class="dot-img mx-1"
							[class.active]="i === currentIndex"
							(click)="irA(i)"
						></span>
					</div>
					</div>

				</div>
				

			</div>

		</div>

	</div>
</mat-dialog-content>

<div class="modal-footer">
	<button mat-raised-button color="primary" mat-dialog-close>Cerrar</button>
</div>